import { useTranslation } from "react-i18next";

// The small "Retry" link under a field or message whose data failed to load.
export default function InlineRetry({ onRetry, className = "self-start" }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onRetry}
      className={`${className} text-[10px] font-black text-rose-600 uppercase tracking-widest hover:text-rose-800`}
    >
      {t("common.retry")}
    </button>
  );
}
